export default {
  methods: {
    validateNum (number) {
      if (typeof number === 'string') {
        number = +number.replace(/[^.\d;]/, '')
      }
      if (isNaN(number)) {
        return 0
      } else {
        return number
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/validateNum.js